// extracted by mini-css-extract-plugin
export default {"divider":"QnMBpYRkP540QlEhLdM8"};